export const RegexList = {
  /**
   * input: `235/65R17 108V XL EC6`
   *
   * output: `["215/55R17 94V EC6 AO","215","/","55","R","17","94V EC6 AO"]`
   */
  dimensionsFromDescription: /([0-9]+)(\/)([0-9]+)(R)([0-9]+) ([a-zA-Z0-9 ]+)/,
};
